import ClassNames from "classnames";
import { FunctionComponent, useRef } from "react";
import { selectActiveSite } from "../../selectors/sites.js";
import { useAppSelector } from "../../store/hooks.js";
import moduleBaseStyles from "../../stylesheets/components/module-base.module.css";
import styles from "../../stylesheets/components/price-module.module.css";
import {
  BaseModuleProps,
  PriceModuleSettings,
  PricesWidgetSettings,
} from "../../types/index.js";
import {
  getActiveColorScheme,
  getSupportedLanguage,
} from "../../utils/utils.js";
import ModuleHeadings from "../ModuleHeadings.js";
import ModuleWithHeadings from "../ModuleWithHeadings.js";
import PricesWidget from "../PricesWidget.js";
import RichEditorWrapper from "../RichEditorWrapper.js";

interface Props extends BaseModuleProps<PriceModuleSettings> {}

const PriceModule: FunctionComponent<Props> = ({
  translatedModule,
  translatedModule: {
    id: moduleId,
    settings: { textAlign, grouping, layout, roomIds, offerIds, boardIds },
    translation: {
      settings: { title, subtitle },
      languageId,
    },
  },
  pageId,
  isPreview,
  isFirstOnPage,
}) => {
  const site = useAppSelector(selectActiveSite);
  const scheme = useAppSelector((state) =>
    getActiveColorScheme(state.colorSchemes, site, translatedModule),
  );

  const settings: PricesWidgetSettings = {
    propertyId: site.accommodation.id,
    lang: getSupportedLanguage(languageId, ["de", "it", "en", "fr"]),
    colorScheme: scheme,
    grouping,
    layout,
    roomIds: roomIds.length ? roomIds : undefined,
    offerIds: offerIds.length ? offerIds : undefined,
    boardIds: boardIds.length ? boardIds : undefined,
  };

  const ref = useRef<HTMLDivElement>(null);

  return (
    <ModuleWithHeadings
      innerRef={ref}
      title={title}
      subtitle={subtitle}
      id={moduleId}
      className={styles.PriceModule}
      colors={{ background: scheme.main.separator, color: scheme.main.text }}
    >
      <div className={moduleBaseStyles.Module__Wrapper}>
        <ModuleHeadings
          scheme={scheme}
          isFirstOnPage={isFirstOnPage}
          textAlign={textAlign}
          title={title}
          subtitle={subtitle}
        />

        <PricesWidget settings={settings} />

        <RichEditorWrapper
          module={translatedModule}
          pageId={pageId}
          languageId={languageId}
          isPreview={isPreview}
          scheme={scheme}
          className={ClassNames(
            styles.PriceModule__AdditionalInfos,
            `TextAlign--${textAlign.description}`,
          )}
        />
      </div>
    </ModuleWithHeadings>
  );
};

export default PriceModule;
